import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";

import logger from "../../../utils/LoggerFrontend.js";
import Actions from "../../../Actions";
import { Store__System } from "@talentbait/shared-components";
import { useTranslation } from "react-i18next";
import { withRefluxStore } from "../../../Stores";

import * as SC from "./styles";
import { ArrowRightIcon } from "../Previews/Svg";
import { ACTION_MESSAGES } from "../../../Permissions/constants.js";
import { saveUserFlatLogService } from "../../../services/UserLogFlatService.js";

const ChooseCampaign = ({ history, userProfile, organization }) => {
  const { t } = useTranslation();

  const jobPostingId = "job-posting";
  const employerBrandingId = "employer-branding";

  const [optionSelectedId, setOptionSelectedId] = useState(jobPostingId);
  const [hideEmployerBrandingABTest, setHideEmployerBrandingABTest] = useState(false);

  useEffect(() => {
    saveUserFlatLogService({
      userProfile,
      orgaId: organization?.id,
      orgaName: organization?.name,
      actionType: ACTION_MESSAGES.CREATE.CAMPAIGNS.TYPE,
      message: ACTION_MESSAGES.CREATE.CAMPAIGNS.SUCCESS_ACTION
    });
  }, [userProfile, organization]);

  const handleCheckBoxChange = () => {
    setHideEmployerBrandingABTest(!hideEmployerBrandingABTest);
  };

  const selectedBorderStyle = "1px solid #1C22FF";

  const saveUserPreferences = async () => {
    const loggerBody = {
      useEmployerBranding: !hideEmployerBrandingABTest
    };

    const ref = Actions.updateUser.completed.listen(() => {
      logger.log("ChooseCampaign:saveUserEmployerBranding:completed", "Completed: ", loggerBody);

      if (window.analytics) {
        window.analytics.track("Hide Employer Branding button clicked", {
          source: "Choose Campaign - Employer Branding",
          option: loggerBody,
          userId: userProfile.userId,
          userName: userProfile.userName,
          email: userProfile.email,
          organizationId: organization.id,
          organizationName: organization.name
        });
      }

      Actions.loadUserProfile();

      ref();
    });

    const refError = Actions.updateUser.failed.listen((error) => {
      logger.log("ChooseCampaign:saveUserEmployerBranding:failed", "Failed: ", {
        ...loggerBody,
        error
      });

      refError();
    });

    logger.log("ChooseCampaign:saveUserEmployerBranding:called", "Called: ", loggerBody);

    await Actions.updateUser(userProfile.userId, {
      useEmployerBranding: !hideEmployerBrandingABTest
    });
  };

  const handleNextStepRedirection = async () => {
    logger.log("ChooseCampaign:handleNextStepRedirection", "Next Step: ", { optionSelectedId });

    if (window.analytics) {
      window.analytics.track("Campaign selection", {
        source: "Choose Campaign - Employer Branding",
        option: optionSelectedId,
        userId: userProfile.userId,
        userName: userProfile.userName,
        email: userProfile.email,
        organizationId: organization.id,
        organizationName: organization.name
      });
    }

    await saveUserPreferences();

    if (optionSelectedId === jobPostingId) {
      history.push("/new-campaign");
    } else {
      history.push("/employer-branding");
    }
  };

  return (
    <SC.EmployerBrandingWrapper className="fade-in">
      <SC.Header>{t("Create a new Campaign")}</SC.Header>
      <SC.SubHeader>{t("Select what type of campaign you want to create")}</SC.SubHeader>
      <SC.CardWrapper>
        <SC.Card
          data-testid="job-posting-card"
          onClick={() => setOptionSelectedId(jobPostingId)}
          style={{ border: optionSelectedId === jobPostingId ? selectedBorderStyle : "" }}
        >
          <SC.Image src="/images/job-posting.png" alt="job-posting" width={64} height={64} />
          <SC.Description>{t("Job Posting")}</SC.Description>
          <SC.SubDescription>{t("Find Candidates for your Jobs")}</SC.SubDescription>
        </SC.Card>
        <SC.Card
          data-testid="employer-branding-card"
          onClick={() => setOptionSelectedId(employerBrandingId)}
          style={{ border: optionSelectedId === employerBrandingId ? selectedBorderStyle : "" }}
        >
          <SC.Image
            src="/images/employer-branding.png"
            alt="employer-branding"
            width={64}
            height={64}
          />
          <SC.Description>{t("Employer Branding")}</SC.Description>
          <SC.SubDescription>{t("Promote your Organization")}</SC.SubDescription>
          <SC.NewBudget>{t("NEW")}</SC.NewBudget>
        </SC.Card>
      </SC.CardWrapper>
      <SC.CheckBoxContainer>
        <input
          type="checkbox"
          id="hideEmployerBrandingABTest"
          checked={hideEmployerBrandingABTest}
          onChange={handleCheckBoxChange}
        />
        <label htmlFor="hideEmployerBrandingABTest">{t("Don't show again")}</label>
      </SC.CheckBoxContainer>
      <SC.NextButton variant="primary" onClick={handleNextStepRedirection}>
        {t("Next Step")}
        <ArrowRightIcon style={{ marginLeft: "8px", marginTop: "-2px", width: 17, height: 16 }} />
      </SC.NextButton>
    </SC.EmployerBrandingWrapper>
  );
};

export default withRefluxStore(
  withRouter(ChooseCampaign),
  [Store__System],
  ["userProfile", "organization"]
);
